import React from 'react'
import { Link } from "react-router-dom";


const BookAir = () => {
    return (
        <>

            <section className="section-breadcrumb main-wrapper" style={{ overflow: "hidden" }}>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">Our Blog</span>
                            </nav>
                            <h1 className="breadcrumb-title">Our Blog</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-blog" style={{ marginTop: "-40px" }}>
                <div className="section-space section-space-bottom-huge">
                    <div className="container">
                        <div className="row gy-5 g-lg-5">
                            <div className="col-12 col-lg-12 col-xl-12">
                                <h2>Best logistics company in India</h2>
                                <article className="text-rich">
                                    <p>When speed is of the essence and dependability is a must, air cargo services are the most efficient means of transportation. Whether for businesses or individuals, the need for express delivery between cities has increased manifold. Whether it’s e-commerce, retail, pharma, or emergency personal shipments, air cargo puts your products at the doorstep in the minimum amount of time.</p>
                                    <p>Rahul Logistics, India’s one of the fastest-growing logistics firms, offers a convenient domestic air cargo service that aims to serve the time-sensitive delivery demands of today. Through our Jabalpur Air Cargo Services and across major Indian cities, we help you save your time and hassle while delivering peace of mind with every shipment.</p>
                                    {/* <h4>Why Rail Cargo is a Smart Choice</h4>
                                    <ul className="content-list content-list-1">
                                        <li>Cost-Effective: Rail transport is cheaper for long distances and large loads.</li>
                                        <li>Eco-Friendly: Railways produce lower emissions compared to road transport.</li>
                                        <li>Reliable Timings: Trains run on fixed schedules, ensuring punctual deliveries.</li>
                                        <li>Large Volume Capacity: Suitable for industries like manufacturing, construction, and retail.</li>
                                    </ul> */}
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default BookAir